<template lang="pug">
  DefaultLayout
    CommonSection(:title="$route.params.projectId ? 'Редактирование проекта' : 'Новый проект'")
      ProjectForm
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import ProjectForm from '@/components/ProjectForm.vue';

export default {
  name: 'TaskFormPage',
  components: { DefaultLayout, CommonSection, ProjectForm },
};
</script>
